import { TPagingResponse } from './api';

export type TScoreListParams = {
  page: number;
  size: number;
  courseInfoId?: number;
  chartRound?: string;
  searchWord?: string;
  isNotEvaluated: boolean;
  sortBy?: ScoreInfoSortBy;
  isAsc?: boolean;
};

export type TScoreTableInfo = {
  userId: number;
  name: string;
  loginId: string;
  phoneNum: string | null;
  firstEvaluationStatus: string;
  firstEvaluationAvgScore: string | number;
  secondEvaluationStatus: string;
  secondEvaluationAvgScore: string | number;
};

export type TScoreList = {
  chartClosingStatus: {
    firstSubmitEndDate: string;
    firstChartScoreDisclosure: boolean;
    secondSubmitStartDate: string;
    secondSubmitEndDate: string;
    secondChartScoreDisclosure: boolean;
  };
  studentScoreList: TScoreTableInfo[];
};

export type TScoreListResponse = TPagingResponse<TScoreList>;

export type TScoreDetailParams = {
  courseInfoId: number;
  chartRound: number;
  userId?: number;
};

export type TScoreDetailResponse = {
  summaryInfo: {
    courseName: string;
    chartRound: number;
    chartName: string;
    name: string;
    loginId: string;
    isScoreDisclosure: number;
  } | null;
  scoreList: {
    chartType: number;
    chartTypeName: string;
    firstScore: string;
    secondScore: string;
  }[];
};

export type TScoreParams = {
  courseInfoId: number;
  chartRound: number;
};

export enum ScoreInfoSortBy {
  Score1 = 'score1',
  Score2 = 'score2',
}

export enum ScoreInfoSortByFormLabel {
  Score1 = '1차 평가결과',
  Score2 = '2차 평가결과',
}
